import Session from "@lib/session";
import reprice from "@services/reprice";

export default async function removeEpicPass(): Promise<void> {
  // Remove pass from booking object.
  const booking = Session.getBooking();
  booking.otherInfo.epicPassId = undefined;
  Session.updateBooking({ otherInfo: booking.otherInfo });

  const legs = Session.getBooking().activeLegs();

  // For each leg, remove the epicPassValidated flag
  for (const [index, leg] of legs.entries()) {
    if (!leg.epicPassValidated) continue;
    leg.epicPassValidated = false;
    Session.setLeg(index, leg);
    await reprice(index, false);
  }
}
